import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, Transition as _Transition, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "default-content" }
const _hoisted_3 = { class: "options" }
const _hoisted_4 = {
  key: 0,
  class: "buttons"
}
const _hoisted_5 = { class: "collapse-content" }
const _hoisted_6 = { class: "collapse-content" }
const _hoisted_7 = { class: "test-form" }
const _hoisted_8 = { class: "collapse-content" }
const _hoisted_9 = { class: "collapse-content" }
const _hoisted_10 = { class: "collapse-content" }
const _hoisted_11 = { class: "collapse-content" }
const _hoisted_12 = { class: "ticket-form" }
const _hoisted_13 = { class: "tickets-add-label" }

export function render(_ctx, _cache) {
  const _component_Header = _resolveComponent("Header")
  const _component_Navigation = _resolveComponent("Navigation")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_radio_button = _resolveComponent("el-radio-button")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_input_number = _resolveComponent("el-input-number")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_button = _resolveComponent("el-button")
  const _component_VideoPlay = _resolveComponent("VideoPlay")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_Right = _resolveComponent("Right")
  const _component_ChatLineRound = _resolveComponent("ChatLineRound")
  const _component_Warning = _resolveComponent("Warning")
  const _component_RefreshLeft = _resolveComponent("RefreshLeft")
  const _component_List = _resolveComponent("List")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")
  const _component_UserFilled = _resolveComponent("UserFilled")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_Ticket = _resolveComponent("Ticket")
  const _component_Close = _resolveComponent("Close")
  const _component_Check = _resolveComponent("Check")
  const _component_Lock = _resolveComponent("Lock")
  const _component_CircleCheck = _resolveComponent("CircleCheck")
  const _component_CircleClose = _resolveComponent("CircleClose")
  const _component_Document = _resolveComponent("Document")
  const _component_Delete = _resolveComponent("Delete")
  const _component_el_table = _resolveComponent("el-table")
  const _component_CirclePlusFilled = _resolveComponent("CirclePlusFilled")
  const _component_el_collapse = _resolveComponent("el-collapse")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header, {
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["windowWidth", "windowHeight"]),
    _createVNode(_component_Navigation, {
      activeMenu: _ctx.NavigationIndex.TEST,
      windowWidth: _ctx.windowWidth,
      windowHeight: _ctx.windowHeight
    }, null, 8, ["activeMenu", "windowWidth", "windowHeight"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, null, {
              default: _withCtx(() => _cache[16] || (_cache[16] = [
                _createElementVNode("div", { class: "danger" }, [
                  _createElementVNode("h4", null, "Zugang verweigert."),
                  _createElementVNode("p", null, "Sie besitzen nicht die erforderliche Berechtigung für diesen Bereich.")
                ], -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, !_ctx.hasPermission['TEST_UPDATE'] && !_ctx.hasPermission['TEST_QUESTION'] && !_ctx.loading]
        ]),
        (_ctx.testModel)
          ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
              key: 0,
              breadcrumbs: [['Prüfungen', '/test'], [_ctx.testModel.name]]
            }, null, 8, ["breadcrumbs"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_el_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_main, { class: "rounded-content" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_collapse, {
                  modelValue: _ctx.activeName,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => ((_ctx.activeName) = $event)),
                  accordion: "",
                  ref: "coll"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_Transition, { name: "el-zoom-in-bottom" }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_row, { class: "test-labels" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 1,
                                class: "option-label complexity"
                              }, {
                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                  _createTextVNode("Befragungsart")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 1,
                                class: "option-label correctcount"
                              }, {
                                default: _withCtx(() => _cache[18] || (_cache[18] = [
                                  _createTextVNode("Korrekte Antworten")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 1,
                                class: "option-label count"
                              }, {
                                default: _withCtx(() => _cache[19] || (_cache[19] = [
                                  _createTextVNode("Fragenumfang")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 1,
                                class: "option-label limit"
                              }, {
                                default: _withCtx(() => _cache[20] || (_cache[20] = [
                                  _createTextVNode("Prüfungszeit (in Minuten)")
                                ])),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 1,
                                class: "option-label percentage"
                              }, {
                                default: _withCtx(() => _cache[21] || (_cache[21] = [
                                  _createTextVNode("Erfolgreich ab (%)")
                                ])),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_row, { class: "test-options" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_col, {
                                span: 1,
                                class: "option-value complexity"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_group, {
                                    modelValue: _ctx.selectedComplexity,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.selectedComplexity) = $event)),
                                    onChange: _ctx.onComplexityChange,
                                    disabled: _ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH && _ctx.hasPermission['TEST_UPDATE'] ? false : true
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_radio_button, {
                                        value: _ctx.testComplexity[0],
                                        label: _ctx.testComplexity[0]
                                      }, null, 8, ["value", "label"]),
                                      _createVNode(_component_el_radio_button, {
                                        value: _ctx.testComplexity[1],
                                        label: _ctx.testComplexity[1]
                                      }, null, 8, ["value", "label"])
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onChange", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 1,
                                class: "option-value correctcount"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_group, {
                                    modelValue: _ctx.showCorrectCount,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.showCorrectCount) = $event)),
                                    onChange: _ctx.onCorrectShowChange,
                                    disabled: _ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH && _ctx.hasPermission['TEST_UPDATE'] ? false : true
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_radio_button, {
                                        value: false,
                                        label: "ausblenden"
                                      }),
                                      _createVNode(_component_el_radio_button, {
                                        value: true,
                                        label: "anzeigen"
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onChange", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 1,
                                class: "option-value count"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_group, {
                                    modelValue: _ctx.testModel.questioncount,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.testModel.questioncount) = $event)),
                                    onChange: _ctx.onQuestionCountChange,
                                    disabled: _ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH && _ctx.hasPermission['TEST_UPDATE']? false : true
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_radio_button, {
                                        value: 10,
                                        label: 10
                                      }),
                                      _createVNode(_component_el_radio_button, {
                                        value: 28,
                                        label: 28
                                      }),
                                      _createVNode(_component_el_radio_button, {
                                        value: 60,
                                        label: 60
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onChange", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 1,
                                class: "option-value limit"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_radio_group, {
                                    modelValue: _ctx.testModel.timelimit,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.testModel.timelimit) = $event)),
                                    onChange: _ctx.onTimelimitChange,
                                    disabled: _ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH && _ctx.hasPermission['TEST_UPDATE'] ? false : true
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_radio_button, {
                                        value: 10,
                                        label: 10
                                      }),
                                      _createVNode(_component_el_radio_button, {
                                        value: 60,
                                        label: 60
                                      }),
                                      _createVNode(_component_el_radio_button, {
                                        value: 120,
                                        label: 120
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "onChange", "disabled"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_col, {
                                span: 1,
                                class: "option-value percentage"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input_number, {
                                    modelValue: _ctx.testModel.successpct,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.testModel.successpct) = $event)),
                                    min: 1,
                                    max: 100,
                                    onChange: _ctx.onSuccessPercentageChange,
                                    disabled: _ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH && _ctx.hasPermission['TEST_UPDATE'] ? false : true
                                  }, null, 8, ["modelValue", "onChange", "disabled"])
                                ]),
                                _: 1
                              }),
                              (!_ctx.loadingTest && _ctx.participantList && _ctx.participantList.length > 0 && _ctx.hasPermission['TEST_UPDATE'])
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 0,
                                    span: 2,
                                    align: "right"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                        onClick: _ctx.onDownloadClick,
                                        disabled: _ctx.downloadingXLS,
                                        link: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_image, {
                                            src: "/img/excel.png",
                                            class: "excel",
                                            title: "Prüflingsliste als Excel herunterladen"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["onClick", "disabled"])), [
                                        [_directive_loading, _ctx.downloadingXLS]
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.loadingTest && _ctx.testModel && _ctx.testModel.statusid >= _ctx.Status.TEST_PENDING && _ctx.hasPermission['TEST_UPDATE'])
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 1,
                                    span: 1,
                                    align: "right"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                        disabled: _ctx.downloadingQuestions,
                                        onClick: _cache[5] || (_cache[5] = $event => (_ctx.onDownloadQuestionListClick(_ctx.testModel))),
                                        link: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_image, {
                                            src: "/img/pdf_question.png",
                                            class: "excel",
                                            title: "Fragebogen für den Ausdruck herunterladen"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])), [
                                        [_directive_loading, _ctx.downloadingQuestions]
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.loadingTest && _ctx.testModel && _ctx.testModel.statusid >= _ctx.Status.TEST_PENDING && _ctx.hasPermission['TEST_UPDATE'])
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 2,
                                    span: 1,
                                    align: "right"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                        onClick: _cache[6] || (_cache[6] = $event => (_ctx.onDownloadQuestionSolutionClick(_ctx.testModel))),
                                        disabled: _ctx.downloadingSolutions,
                                        link: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_image, {
                                            src: "/img/pdf_solution.png",
                                            class: "excel",
                                            title: "Lösungsschablone für den Ausdruck herunterladen"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])), [
                                        [_directive_loading, _ctx.downloadingSolutions]
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.loadingTest && _ctx.testModel && _ctx.testModel.statusid >= _ctx.Status.TEST_FINISH && _ctx.hasPermission['TEST_EVAL'])
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 3,
                                    span: 1,
                                    align: "right"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                        onClick: _cache[7] || (_cache[7] = $event => (_ctx.onDownloadEvaluationClick())),
                                        disabled: _ctx.downloadingEvaluation,
                                        link: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_el_image, {
                                            src: "/img/pdf_eval.png",
                                            class: "excel",
                                            title: "Evaluierung für diese Prüfung herunterladen"
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled"])), [
                                        [_directive_loading, _ctx.downloadingEvaluation]
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ], 512), [
                          [_vShow, !_ctx.loadingTest]
                        ])
                      ]),
                      _: 1
                    }),
                    ( _ctx.participantList && _ctx.participantList.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                          _createVNode(_component_el_row, { class: "test-buttons" }, {
                            default: _withCtx(() => [
                              (_ctx.testModel.startdate <= 0 && _ctx.testModel.stopdate <= 0 && _ctx.hasPermission['TEST_UPDATE'])
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 0,
                                    span: 1,
                                    class: "button-begin",
                                    align: "left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        size: "large",
                                        disabled: !_ctx.formValid,
                                        onClick: _ctx.onStartClick
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[22] || (_cache[22] = _createTextVNode(" Prüfung vorbereiten  ")),
                                          _createVNode(_component_el_icon, { size: 20 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_VideoPlay)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.testModel.startdate > 0 && _ctx.testModel.stopdate <= 0)
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 1,
                                    span: 1,
                                    class: "button-begin",
                                    align: "left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        type: "warning",
                                        size: "large",
                                        disabled: !_ctx.formValid,
                                        onClick: _ctx.onStartClick
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[23] || (_cache[23] = _createTextVNode(" Prüfung fortsetzen  ")),
                                          _createVNode(_component_el_icon, { size: 20 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Right)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_DRAFT && _ctx.hasPermission['TEST_QUESTION'])
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 2,
                                    span: 1,
                                    class: "button-questions",
                                    align: "left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        size: "large",
                                        disabled: !_ctx.formValid,
                                        onClick: _ctx.onEditClick
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[24] || (_cache[24] = _createTextVNode(" Fragebogen  ")),
                                          _createVNode(_component_el_icon, { size: 20 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ChatLineRound)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (false && _ctx.testModel && _ctx.testModel.stopdate > 0 && _ctx.hasPermission['TEST_QUESTION'])
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 3,
                                    span: 1,
                                    class: "button-procedure",
                                    align: "left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        size: "large",
                                        disabled: !_ctx.formValid,
                                        onClick: _ctx.onAppealClick
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[25] || (_cache[25] = _createTextVNode(" Widerspruchsverfahren  ")),
                                          _createVNode(_component_el_icon, { size: 20 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Warning)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH && _ctx.hasPermission['TEST_UPDATE'] && (_ctx.testModel.statusid != _ctx.Status.TEST_DRAFT || _ctx.testModel.stopdate > 0))
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 4,
                                    span: 1,
                                    class: "button-reset",
                                    align: "left"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        type: "danger",
                                        size: "large",
                                        disabled: !_ctx.formValid,
                                        onClick: _ctx.onResetClick
                                      }, {
                                        default: _withCtx(() => [
                                          _cache[26] || (_cache[26] = _createTextVNode(" Prüfung zurücksetzen  ")),
                                          _createVNode(_component_el_icon, { size: 20 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_RefreshLeft)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["disabled", "onClick"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.testModel && _ctx.testModel.statusid == _ctx.Status.TEST_FINISH)
                                ? (_openBlock(), _createBlock(_component_el_col, {
                                    key: 5,
                                    class: "results",
                                    span: 8,
                                    align: "right"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" Erfolgsquote: " + _toDisplayString(_ctx.getTestResult()) + "% ", 1)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_collapse_item, { name: "1" }, {
                      title: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_el_icon, { size: 32 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_List)
                            ]),
                            _: 1
                          })
                        ]),
                        _cache[27] || (_cache[27] = _createElementVNode("div", { class: "title-label" }, "Prüfungsdetails", -1))
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_el_form, {
                              ref: "editTestForm",
                              rules: _ctx.rules,
                              "label-position": "top",
                              model: _ctx.testModel,
                              "label-width": "120px"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_form_item, {
                                  label: "Name",
                                  prop: "name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.testModel.name,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.testModel.name) = $event)),
                                      onInput: _ctx.onInput,
                                      readonly: _ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH ? false : true
                                    }, null, 8, ["modelValue", "onInput", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, { label: "Datum" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_date_picker, {
                                      modelValue: _ctx.testDate,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.testDate) = $event)),
                                      type: "datetime",
                                      placeholder: "Bitte wählen...",
                                      format: "DD.MM.YYYY HH:mm",
                                      onChange: _ctx.onInput,
                                      readonly: _ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH ? false : true
                                    }, null, 8, ["modelValue", "onChange", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "Primäre Zielgruppe",
                                  prop: "targetgroupid"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_select, {
                                      modelValue: _ctx.testModel.targetgroupid,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.testModel.targetgroupid) = $event)),
                                      placeholder: "Bitte wählen...",
                                      onChange: _ctx.onInput,
                                      disabled: _ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH ? false : true
                                    }, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetGroupList, (item) => {
                                          return (_openBlock(), _createBlock(_component_el_option, {
                                            key: item.targetgroupid,
                                            label: item.name,
                                            value: item.targetgroupid
                                          }, null, 8, ["label", "value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    }, 8, ["modelValue", "onChange", "disabled"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_form_item, {
                                  label: "Notizen",
                                  prop: "note"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.testModel.note,
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.testModel.note) = $event)),
                                      onInput: _ctx.onInput,
                                      readonly: _ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH ? false : true
                                    }, null, 8, ["modelValue", "onInput", "readonly"])
                                  ]),
                                  _: 1
                                }),
                                (_ctx.hasPermission['TEST_UPDATE'])
                                  ? (_openBlock(), _createBlock(_component_el_form_item, { key: 0 }, {
                                      default: _withCtx(() => [
                                        (_ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH)
                                          ? (_openBlock(), _createBlock(_component_el_button, {
                                              key: 0,
                                              type: "primary",
                                              disabled: !_ctx.formValid,
                                              onClick: _ctx.onSaveClick
                                            }, {
                                              default: _withCtx(() => _cache[28] || (_cache[28] = [
                                                _createTextVNode(" Speichern ")
                                              ])),
                                              _: 1
                                            }, 8, ["disabled", "onClick"]))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["rules", "model"])
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    (_ctx.hasPermission['TEST_UPDATE'])
                      ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                          key: 1,
                          name: "2"
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_UserFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[29] || (_cache[29] = _createElementVNode("div", { class: "title-label" }, "Liste der Prüflinge", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_9, [
                              _withDirectives((_openBlock(), _createBlock(_component_el_table, { data: _ctx.participantList }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, { label: "Teilnahme-ID" }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(_ctx.participantList[scope.$index].prefix + '-' + _ctx.participantList[scope.$index].token), 1)
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.clientList.length > 1)
                                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: 0,
                                        label: "Amt"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createVNode(_component_el_select, {
                                            modelValue: _ctx.participantList[scope.$index].clientid,
                                            "onUpdate:modelValue": $event => ((_ctx.participantList[scope.$index].clientid) = $event),
                                            placeholder: "Bitte wählen...",
                                            onChange: $event => (_ctx.onClientChange(_ctx.participantList[scope.$index])),
                                            disabled: (_ctx.testModel.statusid <= 0 || _ctx.testModel.statusid == _ctx.Status.TEST_FINISH || _ctx.testModel.statusid == _ctx.Status.TEST_ABORT)
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientList, (item) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: item.clientid,
                                                  label: item.name,
                                                  value: item.clientid
                                                }, null, 8, ["label", "value"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "onChange", "disabled"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_el_table_column, { label: "Zielgruppe" }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(_ctx.getTargetGroup(_ctx.participantList[scope.$index].targetgroupid) ? _ctx.getTargetGroup(_ctx.participantList[scope.$index].targetgroupid).name : '-'), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    label: "Teilnahme",
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (_ctx.participantList[scope.$index].datestart > 0)
                                        ? (_openBlock(), _createBlock(_component_el_icon, {
                                            key: 0,
                                            size: 20,
                                            class: "passed",
                                            title: "teilgenommen"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Ticket)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    label: "Prüfungsergebnis",
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (_ctx.participantList[scope.$index].datestart > 0 && !_ctx.participantList[scope.$index].haspassed && !_ctx.participantList[scope.$index].isdisqualified)
                                        ? (_openBlock(), _createBlock(_component_el_icon, {
                                            key: 0,
                                            size: 20,
                                            class: "failed",
                                            title: "durchgefallen"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Close)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.participantList[scope.$index].datestart > 0 && _ctx.participantList[scope.$index].haspassed && !_ctx.participantList[scope.$index].isdisqualified)
                                        ? (_openBlock(), _createBlock(_component_el_icon, {
                                            key: 1,
                                            size: 20,
                                            class: "passed",
                                            title: "bestanden"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Check)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true),
                                      (_ctx.participantList[scope.$index].datestop > 0 && _ctx.participantList[scope.$index].isdisqualified)
                                        ? (_openBlock(), _createBlock(_component_el_icon, {
                                            key: 2,
                                            size: 20,
                                            class: "failed",
                                            title: "disqualifiziert"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Lock)
                                            ]),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "dateupdate",
                                    label: "Letzte Änderung",
                                    width: "200"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createTextVNode(_toDisplayString(new Intl.DateTimeFormat('de-DE', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'}).format(new Date(0).setUTCSeconds(_ctx.participantList[scope.$index].dateupdate))), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    fixed: "right",
                                    label: "",
                                    width: "60",
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (_ctx.participantList[scope.$index].datestart > 0 && _ctx.participantList[scope.$index].datestop > 0)
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 0,
                                            type: (_ctx.participantList[scope.$index].isapproved ? 'success' : 'danger'),
                                            title: ('Ergebnis ist ' + (_ctx.participantList[scope.$index].isapproved ? 'freigegeben' : 'nicht freigegeben')),
                                            onClick: $event => (_ctx.onApproveParticipantClick(_ctx.participantList[scope.$index])),
                                            circle: ""
                                          }, {
                                            default: _withCtx(() => [
                                              (_ctx.participantList[scope.$index].isapproved)
                                                ? (_openBlock(), _createBlock(_component_el_icon, {
                                                    key: 0,
                                                    size: 16
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_CircleCheck)
                                                    ]),
                                                    _: 1
                                                  }))
                                                : (_openBlock(), _createBlock(_component_el_icon, {
                                                    key: 1,
                                                    size: 16
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_CircleClose)
                                                    ]),
                                                    _: 1
                                                  }))
                                            ]),
                                            _: 2
                                          }, 1032, ["type", "title", "onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    fixed: "right",
                                    label: "",
                                    width: "60",
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (_ctx.participantList[scope.$index].datestop > 0)
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 0,
                                            type: "primary",
                                            title: "Prüfungsergebnis herunterladen",
                                            onClick: $event => (_ctx.onDownloadPDFClick(_ctx.participantList[scope.$index])),
                                            circle: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, { size: 16 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Document)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    fixed: "right",
                                    label: "",
                                    width: "60",
                                    align: "center"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (_ctx.participantList[scope.$index].datestop > 0)
                                        ? (_openBlock(), _createBlock(_component_el_button, {
                                            key: 0,
                                            type: "primary",
                                            title: "Prüfungsfragen herunterladen",
                                            onClick: $event => (_ctx.onDownloadQuestionsClick(_ctx.participantList[scope.$index])),
                                            circle: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, { size: 16 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_List)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }),
                                  (_ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH)
                                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                                        key: 1,
                                        fixed: "right",
                                        label: "",
                                        width: "60"
                                      }, {
                                        default: _withCtx((scope) => [
                                          _createVNode(_component_el_button, {
                                            type: "danger",
                                            onClick: $event => (_ctx.onParticipantDeleteClick(_ctx.participantList[scope.$index])),
                                            circle: ""
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_el_icon, { size: 16 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Delete)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              }, 8, ["data"])), [
                                [_directive_loading, _ctx.loading]
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.testModel && _ctx.testModel.statusid != _ctx.Status.TEST_FINISH && _ctx.hasPermission['TEST_UPDATE'])
                      ? (_openBlock(), _createBlock(_component_el_collapse_item, {
                          key: 2,
                          name: "3"
                        }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_el_icon, { size: 32 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_CirclePlusFilled)
                                ]),
                                _: 1
                              })
                            ]),
                            _cache[30] || (_cache[30] = _createElementVNode("div", { class: "title-label" }, "Prüfling registrieren", -1))
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_11, [
                              _createElementVNode("div", _hoisted_12, [
                                _createVNode(_component_el_form, {
                                  ref: "newParticipantForm",
                                  "label-position": "top"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_form_item, { label: "Ticketliste" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_select, {
                                          modelValue: _ctx.tokenListId,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.tokenListId) = $event)),
                                          onChange: _ctx.onTokenListSelect,
                                          placeholder: "Bitte wählen ..."
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokenLists, (item) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: item.tokenlistid,
                                                label: item.name,
                                                value: item.tokenlistid
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        }, 8, ["modelValue", "onChange"])
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.tokens && _ctx.tokens.length > 0)
                                      ? (_openBlock(), _createBlock(_component_el_row, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_col, { span: 12 }, {
                                              default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_13, [
                                                  _cache[32] || (_cache[32] = _createTextVNode(" Anzahl freier Tickets hinzufügen ")),
                                                  _createVNode(_component_el_input_number, {
                                                    modelValue: _ctx.ticketsToAdd,
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.ticketsToAdd) = $event)),
                                                    min: 1,
                                                    max: _ctx.tokens.length
                                                  }, null, 8, ["modelValue", "max"]),
                                                  _cache[33] || (_cache[33] = _createTextVNode("  ")),
                                                  _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                                                    type: "primary",
                                                    disabled: _ctx.tokens.length < _ctx.ticketsToAdd,
                                                    onClick: _ctx.onAddMultipleParticipantsClick
                                                  }, {
                                                    default: _withCtx(() => _cache[31] || (_cache[31] = [
                                                      _createTextVNode(" Hinzufügen ")
                                                    ])),
                                                    _: 1
                                                  }, 8, ["disabled", "onClick"])), [
                                                    [_directive_loading, _ctx.adding]
                                                  ])
                                                ])
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.tokenId > 0 && _ctx.testModel.ismixed)
                                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                                          key: 1,
                                          label: "Zielgruppe"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_select, {
                                              modelValue: _ctx.targetGroupId,
                                              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.targetGroupId) = $event)),
                                              placeholder: "Bitte wählen...",
                                              onChange: _ctx.onInput
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.targetGroupList, (item) => {
                                                  return (_openBlock(), _createBlock(_component_el_option, {
                                                    key: item.targetgroupid,
                                                    label: item.name,
                                                    value: item.targetgroupid
                                                  }, null, 8, ["label", "value"]))
                                                }), 128))
                                              ]),
                                              _: 1
                                            }, 8, ["modelValue", "onChange"])
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 512)
                              ])
                            ])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.hasPermission['TEST_UPDATE'] || _ctx.hasPermission['TEST_QUESTION']]
        ])
      ])
    ])
  ], 64))
}